const { connect } = require('react-redux');
const { context } = require('app-context');
const DiscoverPage = require('../components/DiscoverPage');
const { analyticsTemplates } = require('utils/analytics');
const SearchFilterApplicability = require('components/UserSearchFilterDialog/filterApplicability');

const selectors = context.selectors.all;
const actions = context.actions;
const redux = context.redux.hooks;

const internals = {};

module.exports = connect(
    (state) => {

        const results = selectors.getUsers_forUserSearch(state) || [];

        return {
            results,
            interestsLoading: !results.length && selectors.getIsLoadingInterests(state),
            initLoading: selectors.getIsInitLoading_forUserSearch(state),
            loading: selectors.getIsLoading_forUserSearch(state),
            loadingNextPage: selectors.getIsLoadingNextPage_forUserSearch(state),
            hasPassionInterests: selectors.currentUserHasPassionInterests(state),
            showLoadMore: selectors.getShowLoadMore_forUserSearch(state),
            discoverSortType: selectors.getDiscoverSortType(state),
            canSearchHousing: selectors.getCanSearchHousing_forUserSearch(state),
            canSearchHometown: selectors.getCanSearchHometown_forUserSearch(state),
            interestsActiveFilter: selectors.getInterestsActiveFilter(state),
            isParent: selectors.isParentPermission(state),
            badges: selectors.getAllBadges(state),
            departments: selectors.getDepartmentsList_forProfileEditPage(state),
            yearsHiredList: selectors.getAllYearsHired(state),
            officesList: selectors.getAllOffices(state),
            isCompany: selectors.getSchoolIsCompany(state),
            isCommunity: selectors.getSchoolIsCommunity(state),
            isSchoolOnline: selectors.getSchoolIsOnline(state),
            majors: selectors.getMajorsList_forCurrentUser(state),
            discoverNavigation: selectors.getDiscoverNavigation(state),
            rolePermissions: selectors.getCurrentUserRolePermissions(state),
            discoverSearchFilter: selectors.getDiscoverSearchFilter(state),
            roleGroupFilter: selectors.getRoleGroupFilter(state, 'discover'),
            availableRoleGroups: selectors.getSchoolUsedRoleGroups(state),
            debug: selectors.getDebug(state).discoverMatching
        };
    },
    {
        // eslint-disable-next-line hapi/no-arrowception, hapi/hapi-scope-start
        onClickChangeSortType: (sortType) => (dispatch, getState) => {

            dispatch(actions.app.setDiscoverSortType({ type: sortType }));

            const state = getState();
            const searchFilter = internals.filterOutEmpty(internals.pruneSearchCriteria(selectors.getDiscoverSearchFilter(state), state));

            if (searchFilter && Object.keys(searchFilter).length > 0 &&
                (!searchFilter.allByMatches || searchFilter.contextFilter)) {
                return dispatch(actions.dataFetching.fetchDiscoverSearchResults.firstPage({
                    ...searchFilter,
                    sortType
                }));
            }

            return dispatch(actions.dataFetching.fetchDiscoverSearchResults.firstPage({
                allByMatches: true,
                sortType
            }));
        },
        // eslint-disable-next-line hapi/no-arrowception, hapi/hapi-scope-start
        onClickResetSearchFilters: (sortType) => (dispatch) => {

            dispatch(actions.app.setDiscoverSearchFilter({ filter: {} }));
            dispatch(actions.app.setRoleGroupFilter({ discover: 'all' }));

            const state = redux.getState();

            const {
                discoverMatching: debug
            } = selectors.getDebug(state);

            return dispatch(actions.dataFetching.fetchDiscoverSearchResults.firstPage({
                allByMatches: true,
                sortType,
            // The school-level flag controls whether the API returns debug details.
            // Request them consistently so the URL is never part of the contract.
            debugMatching: true
            }));
        },
        onClickLoadMore: actions.dataFetching.fetchDiscoverSearchResults.nextPage,
        // NOTE I wish I could easily DRY this with the other 'onSubmitSearch'
        // in 'ClassDetailPage', but the funcs are slightly different at the bottom
        // eslint-disable-next-line hapi/no-arrowception, hapi/hapi-scope-start
        onSubmitSearch: (...args) => (dispatch) => internals.onSubmitSearch(...args)(dispatch),
        // eslint-disable-next-line hapi/no-arrowception, hapi/hapi-scope-start
        rememberScroll: () => (dispatch) => {

            return dispatch(actions.app.rememberScroll({ type: 'discover' }));
        },
        // eslint-disable-next-line hapi/no-arrowception, hapi/hapi-scope-start
        restoreScroll: () => (dispatch) => {

            return dispatch(actions.app.restoreScroll({ type: 'discover' }));
        },
        // eslint-disable-next-line hapi/no-arrowception, hapi/hapi-scope-start
        setRoleGroupFilter: (val) => (dispatch, getState) => {

            const state = getState();

            const savedCriteria = Object.fromEntries(Object.entries(
                selectors.getDiscoverSearchFilter(state) || {}
            ).filter(([key]) => !internals.SEARCH_MODE_KEYS.has(key)));

            const nextCriteria = {
                ...savedCriteria,
                contextFilter: val === 'all' ? null : val
            };
            const newCriteria = internals.filterOutEmpty(internals.pruneSearchCriteria(nextCriteria, state));

            dispatch(actions.app.setRoleGroupFilter({ discover: val }));
            dispatch(actions.app.setDiscoverSearchFilter({ filter: newCriteria }));

            // Call shared internal submit handler
            internals.onSubmitSearch(
                newCriteria,
                selectors.getDiscoverSortType(state)
            )(dispatch);
        },
        clearDiscoverNavigation: actions.app.clearDiscoverNavigation
    }
)(DiscoverPage);

internals.SEARCH_MODE_KEYS = new Set([
    'allByMatches',
    'debugMatching',
    'isBasicSearch',
    'sortType',
    'useMatchScoring'
]);

internals.filterOutEmpty = (obj = {}) => {

    const { isBool } = internals;

    return Object.keys(obj).filter((key) => {

        const value = obj[key];
        if (key === 'customLocation') {
            return value && typeof value === 'object' && value.placeId && value.name;
        }

        if (Array.isArray(value)) {
            return !!value.length;
        }

        if (typeof value === 'object' && value !== null) {
            const hasValues = Object.values(value).some((v) => v !== null && v !== undefined && v !== '');
            return hasValues;
        }

        return isBool(value) || !!value;
    })
        .reduce((collector, key) => {

            collector[key] = obj[key];
            return collector;
        }, {});
};

internals.isBool = (maybeBool) => {

    if (String(maybeBool) === 'true' || String(maybeBool) === 'false') {
        return true;
    }

    return false;
};

internals.getInterestId = (interest) => {

    if (interest && typeof interest === 'object') {
        return interest.id;
    }

    return interest;
};

internals.pruneSearchCriteria = (criteria, state) => SearchFilterApplicability.pruneForSelectedUserType(criteria, {
    allRoles: selectors.getRoles(state),
    availableRoleGroups: selectors.getSchoolUsedRoleGroups(state),
    badges: selectors.getAllBadges(state),
    canSearchHometown: selectors.getCanSearchHometown_forUserSearch(state),
    canSearchHousing: selectors.getCanSearchHousing_forUserSearch(state),
    currentUserPermissions: selectors.getCurrentUserRolePermissions(state),
    departments: selectors.getDepartmentsList_forProfileEditPage(state),
    fieldNames: SearchFilterApplicability.DEFAULT_FIELD_NAMES,
    isCompany: selectors.getSchoolIsCompany(state),
    isCommunity: selectors.getSchoolIsCommunity(state),
    isSchoolOnline: selectors.getSchoolIsOnline(state),
    schoolRoles: selectors.getSchoolUsedRoles(state)
});

// eslint-disable-next-line hapi/no-arrowception, hapi/hapi-scope-start
internals.onSubmitSearch = (criteria, sortType) => (dispatch) => {

    const state = redux.getState();
    const prunedCriteria = internals.pruneSearchCriteria(criteria, state);
    const hasCustomLocation = prunedCriteria?.locationType === 'custom' && prunedCriteria.customLocation;
    const customLocationData = hasCustomLocation ? { ...prunedCriteria.customLocation } : null;

    const filteredCriteria = prunedCriteria ? internals.filterOutEmpty(prunedCriteria) : {};

    const searchKeys = prunedCriteria ? Object.keys(filteredCriteria) : [];
    const defaultOnlyKeys = ['contextFilter', 'contextFilterType'];
    const searchValueKeys = searchKeys.filter((key) => !defaultOnlyKeys.includes(key));

    // Default back to 'allByMatches: true' if 'includeStaff' is true
    if (searchKeys.length === 1 && filteredCriteria.includeStaff) {
        delete filteredCriteria.includeStaff;
    }

    analyticsTemplates.buttons('submit peers search', `discover: search submit ${searchKeys.length ? searchKeys : 'empty'}`);

    if (searchValueKeys.length === 0) {
        const {
            discoverMatching: debug
        } = selectors.getDebug(state);

        if (filteredCriteria.contextFilter) {
            dispatch(actions.app.setRoleGroupFilter({ discover: filteredCriteria.contextFilter }));
            dispatch(actions.app.setDiscoverSearchFilter({ filter: filteredCriteria }));
        }

        return dispatch(actions.dataFetching.fetchDiscoverSearchResults.firstPage({
            allByMatches: true,
            sortType,
            debugMatching: true,
            ...(filteredCriteria.contextFilter ? {
                contextFilter: filteredCriteria.contextFilter,
                contextFilterType: filteredCriteria.contextFilterType
            } : {})
        }));
    }

    const {
        interests,
        customLocation,
        ...others
    } = filteredCriteria;

    const search = { ...others };

    if (interests) {
        const interestIds = interests.map(internals.getInterestId)
            .filter((id) => id !== null && id !== undefined && id !== '');

        if (interestIds.length) {
            search.interests = interestIds;
        }
    }

    // Only include customLocation if locationType is 'custom' and we have complete location data
    if (search.locationType === 'custom') {
        const completeCustomLocation = customLocation || customLocationData;

        if (completeCustomLocation?.placeId && completeCustomLocation?.name) {
            search.customLocation = completeCustomLocation;
        }
        else {
            delete search.locationType;
            delete search.radius;
        }
    }

    dispatch(actions.app.setRoleGroupFilter({
        discover: search.contextFilter || 'all'
    }));

    return dispatch(actions.dataFetching.fetchDiscoverSearchResults.firstPage({
        ...search,
        sortType
    }));
};
